<div class="no-items-container">
  <div class="no-item-content">
    <img [src]="iconSrc" [alt]="(placeholderLabel || 'placeholder') + ' icon'" />
    <p class="no-item-content__title">No {{ placeholderLabel | lowercase }}</p>
    <span class="no-item-content__subtitle">You do not have any {{ placeholderLabel | lowercase }} at this time</span>
  </div>
</div>
